module.exports = __webpack_public_path__ + "img/2.2ba6132b.webp";